import { Component, Input, Output, EventEmitter, OnInit, OnDestroy } from '@angular/core';
import { Subject } from 'rxjs/Subject';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/debounceTime';
import 'rxjs/add/operator/distinctUntilChanged';
import 'rxjs/add/operator/switchMap';

@Component({
    selector: 'app-search',
    templateUrl: './search.component.html',
    styleUrls: ['./search.component.scss']
})

export class SearchComponent implements OnInit, OnDestroy {

    @Input() searchData: Array<any>;
    @Input() searchKeys: Array<string>;
    @Input() isDisabled: Boolean = false;
    @Output() presentedResults: EventEmitter<Array<any>> = new EventEmitter<Array<any>>();
    resultData: Array<any> = [];
    searchTerm$ = new Subject<string>();

    ngOnInit() {
        this.searchTerm$
            .debounceTime(400)
            .distinctUntilChanged()
            .subscribe(searchKey => {
                this.onKeySearchInput(searchKey);
            });
    }

    convertNamesFields(searchKeys, indexOfFirstName, indexOfLastName) {
        if (indexOfFirstName >= 0 && indexOfLastName >= 0) {
            searchKeys.splice(indexOfFirstName, indexOfFirstName);
            searchKeys.splice(indexOfLastName, indexOfLastName);
            searchKeys.push('fullName');
            searchKeys.push('fullNameReverse');
        }
    }

    completeFirstAndLastNames(searchKeys, searchRecord, indexOfFirstName, indexOfLastName) {
        if (indexOfFirstName >= 0 && indexOfLastName >= 0) {
            searchRecord['fullName'] = searchRecord['first_name'] + ' ' + searchRecord['last_name'];
            searchRecord['fullNameReverse'] = searchRecord['last_name'] + ' ' + searchRecord['first_name'];
        }
    }

    addImei(user) {
        if (user.band) {
            user['imei'] = user.band.imei;
        }
    }

    checkForPhones(user) {
      user['band_phone_number'] = user.band_phone_number ? user.band_phone_number : '';
    }

    checkForSim(user) {
      user['simNumber'] = user.simNumber ? user.simNumber : '';
    }

    checkForMyGroup(user) {
        user['my_group'] = user.my_group ? user.my_group : '';
        console.log('pasuje grupa' + user.my_group);
    }


  onKeySearchInput(searchValue) {

        const indexOfFirstName = this.searchKeys.indexOf('first_name');
        const indexOfLastName = this.searchKeys.indexOf('last_name');

        this.convertNamesFields(this.searchKeys, indexOfFirstName, indexOfLastName);
        this.resultData = [];
        for (let j = 0; j < this.searchData.length; j++) {
            this.addImei(this.searchData[j]);
            this.checkForPhones(this.searchData[j]);
            this.checkForSim(this.searchData[j]);
            this.checkForMyGroup(this.searchData[j]);
            this.completeFirstAndLastNames(this.searchKeys, this.searchData[j], indexOfFirstName, indexOfLastName);
            for (let z = 0; z < this.searchKeys.length; z++) {
              if (
                this.searchData[j][this.searchKeys[z]] != null && searchValue != null && this.searchData[j][this.searchKeys[z]].toString().toUpperCase()
                  .includes(searchValue.toString().toUpperCase())
              ) {
                this.resultData.push(this.searchData[j]);
              }
            }
        }

        this.resultData = Array.from(new Set(this.resultData));
        (searchValue === '') ? this.presentedResults.emit(this.searchData) : this.presentedResults.emit(this.resultData);

    }

    ngOnDestroy() {
        this.searchTerm$.unsubscribe();
    }

}




// WEBPACK FOOTER //
// ./src/app/shared/components/search/search.component.ts